import { render, staticRenderFns } from "./FlexboxItem.vue?vue&type=template&id=2dde4c55&"
import script from "./FlexboxItem.vue?vue&type=script&lang=js&"
export * from "./FlexboxItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports